
























































































































































































































import {Component, Prop, Vue} from "vue-property-decorator";

import FileSaver from "file-saver";
import {perRoadStore} from "@/store/store";
import {UnitSystem} from "@/interfaces/units";
import SurfaceDeflection from "@/modules/perRoad/views/components/criteria/SurfaceDeflection.vue";
import HorizontalStrainDistribution
  from "@/modules/perRoad/views/components/criteria/HorizontalStrainDistribution.vue";
import ConventionalMeDesignHorizontal
  from "@/modules/perRoad/views/components/criteria/ConventionalMeDesignHorizontal.vue";
import ConventionalMeDesignVertical
  from "@/modules/perRoad/views/components/criteria/ConventionalMeDesignVertical.vue";
import {
  getManyDraws,
  getMonteCarloDraw,
  testWesleaSimulation,
} from "@/modules/perRoad/lib/simulation/monteCarloDraw";
import {
  IPrMonteCarloDrawImperial,
  IWesleaConfig,
  IWesleaConfigBatch,
  IWesleaResult,
  IWesleaResultBatch,
} from "@/modules/perRoad/interfaces/monteCarlo";
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";
import HorizontalStrainDistributionResults
  from "@/modules/perRoad/views/components/monteCarloResults/HorizontalStrainDistributionResults.vue";
import {LayerPerformanceCriteriaLocation, LayerPerformanceCriteriaType} from "@/modules/perRoad/interfaces/perRoad";
import SurfaceDeflectionResults
  from "@/modules/perRoad/views/components/monteCarloResults/SurfaceDeflectionResults.vue";
import ConventionalMeDesignHorizontalResults
  from "@/modules/perRoad/views/components/monteCarloResults/ConventionalMeDesignHorizontalResults.vue";
import ConventionalMeDesignVerticalResults
  from "@/modules/perRoad/views/components/monteCarloResults/ConventionalMeDesignVerticalResults.vue";
import {createPerRoadValidations} from "@/modules/perRoad/lib/validations";
import ProbablisticInputs from "@/modules/lcca/views/components/ProbablisticInputs.vue";
import WesleaConfigInspector from "@/modules/perRoad/views/components/inspection/WesleaConfigInspector.vue";
import Optimization from "@/modules/perRoad/views/components/Optimization.vue";
import {getHorizontalStrainValuesFromWesleaResults} from "@/modules/perRoad/lib/calculations/horizontalStrainDistribution";
// @ts-ignore
// import Module from '@/modules/perRoad/lib/weslea/weslea4.js';


// Module().then((mod) => {
//   console.log('module initialize');
//   console.log(mod._main);
//   console.log('done');
//   // const main = mod.cwrap('main', 'number', '[string]');
//   // console.log('done', main('{a: "b"}'));
// });


Component.registerHooks(["validations"]);

@Component({
  components: {
    Optimization,
    WesleaConfigInspector,
    ProbablisticInputs,
    ConventionalMeDesignVerticalResults,
    ConventionalMeDesignHorizontalResults,
    SurfaceDeflectionResults,
    HorizontalStrainDistributionResults,
    PxNumberInput,
    ConventionalMeDesignHorizontal,
    ConventionalMeDesignVertical,
    HorizontalStrainDistribution,
    SurfaceDeflection,
  },
})
export default class PerRoadSimulation extends Vue {
  @Prop() readonly id!: string;

  @Prop() readonly page!: number;

  plotKey = 0;

  thicknessPlotKey = 0;

  updateThicknessPlotKey() {
    this.thicknessPlotKey += 1;
  }

  get testHorizResults() {
    return getHorizontalStrainValuesFromWesleaResults(this.draws, 1, LayerPerformanceCriteriaLocation.BOTTOM);
  }


  performanceCriteriaType = LayerPerformanceCriteriaType;

  get scenario() {
    return perRoadStore.currentScenario;
  }

  get scenarioImperial() {
    return perRoadStore.currentImperial;
  }

  get isImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial;
  }


  get performanceLocations() {
    return LayerPerformanceCriteriaLocation;
  }

  sync() {
    // this.wesleaResults = {};
    // this.wesleaConfigs = {};
    // this.monteCarloResults = [];
    this.draws = [];
    perRoadStore.setCurrentScenario(this.scenario);
  }

  save() {
    this.sync();
    perRoadStore.saveCurrentScenario();
  }

  validations() {
    return createPerRoadValidations(this.scenarioImperial, this.page);
  }

  saveAFullRunForTesting() {

    const runData = {
      scenario: this.scenarioImperial,
      draws: this.draws,
      wesleaConfigs: this.wesleaConfigs,
      wesleaResults: this.wesleaResults
    };


    const blob = new Blob([JSON.stringify(runData, null, 2)], {type: "text/plain;charset=utf-8"});

    FileSaver.saveAs(blob, "fullRunConfiguration.txt");
  }

  /**
   * Monte carlo
   *
   */

  numRunsInitial = 250;

  currSimulatedScenario: IPrMonteCarloDrawImperial | null = null;

  currWesleaConfig: IWesleaConfig | null = null;

  wesleaResult: any = null;

  get numRunsCompleted() {
    return Object.keys(this.wesleaConfigs).length;
    // return this.draws.length;
  }

  simulateOne() {
    this.currSimulatedScenario = getMonteCarloDraw(this.scenarioImperial);
    // this.currWesleaConfig = createWesleaSimulationFromDraw(this.currSimulatedScenario);
    this.currWesleaConfig = testWesleaSimulation();
    perRoadStore.runOneSimulation(this.currWesleaConfig).then((data) => {
      this.wesleaResult = JSON.parse(data);
    });
  }

  // monteCarloResults: IMonteCarloResultsObject[] = [];

  draws: IPrMonteCarloDrawImperial[] = [];

  drawsMap: { [index: string]: IPrMonteCarloDrawImperial } = {};

  wesleaConfigs: IWesleaConfigBatch = {};

  // wesleaResults: IWesleaResultBatch = {};
  get wesleaResults() {
    return this.draws.filter(d => d.wesleaResult !== null).map(d => d.wesleaResult);
  }

  currentlyRunning = false;

  get showResults() {
    return !this.currentlyRunning && Object.keys(this.wesleaResults).length > 0;
  }

  simulateMany() {
    const startTime = performance.now();

    const simScenarios = getManyDraws(this.numRunsInitial, this.scenarioImperial);


    // this.draws.push(...simScenarios.draws);


    simScenarios.draws.forEach(draw => {
      this.draws.push(draw);
      this.drawsMap[draw.id] = draw;
      if (draw.wesleaConfig) {
        this.wesleaConfigs[draw.id] = draw.wesleaConfig;
      }
    });

    // this.currentlyRunning = true;


    const drawIds = Object.keys(simScenarios.wesleaConfigs);
    const drawStatus: { [index: string]: IWesleaResult | null } = {};
    drawIds.forEach(id => {
      drawStatus[id] = null;
    });

    let completedDraws = 0;

    /**
     * Run each draw individually, even though it's set up to send batches to the server.
     */
    Object.entries(simScenarios.wesleaConfigs).forEach((kv) => {
      const drawId = kv[0];
      const wesConfig = kv[1];

      const packagedConfig: { [index: string]: IWesleaConfig } = {};
      packagedConfig[drawId] = wesConfig;

      perRoadStore.runManySimulations(packagedConfig).then((resultBatch: IWesleaResultBatch) => {
        const id = Object.keys(resultBatch)[0];
        if (id == undefined){
          console.log("Caught")
        } else {
          const result = Object.values(resultBatch)[0];
          completedDraws += 1;
          this.drawsMap[id].wesleaResult = result;
          this.plotKey += 1;
        }
      });
    });

  }

/**
 * Results
 */
}

